import { hasHigherDocumentsLimit } from 'documents-ui/lib/permissions';
export const documentsUsageLimit = 5;
export const isOverFreeLimit = usage => {
  return !hasHigherDocumentsLimit() && usage && usage.count >= documentsUsageLimit;
};